export default __webpack_public_path__ + "static/media/330_business01-es-mobile.39d8b2d2.png";